import { SubtitleWrapper, TitleWrapper, Wrapper } from './TimeWidget.styles';

import { useIsMobile } from '@/hooks';

type Props = {
  title: string;
  subtitle: string;
  isStudent?: boolean;
};

export const TimeWidget: React.FC<Props> = ({ title, subtitle, isStudent }) => {
  const isMobile = useIsMobile();

  if (isMobile || isStudent) return null;

  return (
    <Wrapper>
      <TitleWrapper>{title}</TitleWrapper>
      <SubtitleWrapper>{subtitle}</SubtitleWrapper>
    </Wrapper>
  );
};
